import Noty from 'noty'

export default {
  success (message) {
    new Noty({
      text: message,
      type: 'success',
      theme: 'metroui',
      timeout: 2000,
      progressBar: true
    }).show()
  },
  error (message) {
    new Noty({
      text: message,
      type: 'error',
      theme: 'metroui',
      timeout: 5000,
      progressBar: true
    }).show()
  }
}



// WEBPACK FOOTER //
// ./src/util/Mensajes.js